import * as timeGadgets from './timeGadgets';

export default {
  objEmptyFilter(obj) {
    let o = {};
    for (let i in obj) {
      if (typeof obj[i] !== 'undefined' && obj[i] !== null && obj[i] !== '') {
        o[i] = obj[i];
      }
    }
    return o;
  },
  base64Filter(source) {
    return source.includes('data:image') ? source : `data:image/png;base64,${source}`;
  },

  datetimeFormatter(date) {
    return timeGadgets.datetimeFormatter(date);
  },

  dateFormatter(date) {
    return timeGadgets.dateFormatter(date);
  },
  toDate(source) {
    return typeof source === 'string' ? source.split(' ')[0] : source;
  },

  toYuan(source, noSign = false) {
    return typeof source === 'number' ? `${noSign ? '' : '￥ '}${parseFloat(source / 100).toFixed(2)}` : '-';
  },

  substringForLast4(source) {

    return source ? source.substring(source.length - 4) : ''
  }
};



// WEBPACK FOOTER //
// ./src/gadgets/filters.js